import React from "react";

import experience360 from "assets/graphics/pictures/experience-360.jpg";
import experience768 from "assets/graphics/pictures/experience-768.jpg";
import experience1024 from "assets/graphics/pictures/experience-1024.jpg";
import experience360x2 from "assets/graphics/pictures/experience-360@2x.jpg";
import experience768x2 from "assets/graphics/pictures/experience-768@2x.jpg";
import experience1024x2 from "assets/graphics/pictures/experience-1024@2x.jpg";

import "features/new/calendar/view.scss";

const CalendarView = () => (
  <section id="main__calendar">
    <div className="calendar__img__container">
      <picture className="calendar__image--first main__animation--fade-in">
        <source
          media="(max-width: 360px)"
          srcSet={`${experience360}, ${experience360x2} 2x`}
        />
        <source
          media="(max-width: 767px)"
          srcSet={`${experience768}, ${experience768x2} 2x`}
        />
        <source
          media="(min-width: 768px)"
          srcSet={`${experience1024}, ${experience1024x2} 2x`}
        />
        <img
          src={experience768}
          srcSet={`${experience768x2} 2x`}
          alt="a head carved out of wood"
        />
      </picture>
    </div>
    <div className="calendar__container">
      <div className="calendar__text">
        <h2 className="calendar__headline main__animation--fade-in">
          Parlor
          <br />
          Experience
          {/*Full Social Calendar*/}
        </h2>
        <p className="calendar__description main__animation--fade-in">
          Apply for membership and download the app.
        </p>
        <p className="calendar__description main__animation--fade-in">
          Browse through your personalized calendar and choose events to join.
        </p>
        <p className="calendar__description main__animation--fade-in">
          Use the app to connect and interact with members who are dynamically
          selected for you based on your profile, interests and objectives.
        </p>
      </div>
    </div>
  </section>
);

export default CalendarView;
